export default __webpack_public_path__ + "static/media/interests_icons.0953cc1e.svg";